<div class="main-page">
  <app-header></app-header>

  <div class="container subscription-container">
    <ngx-spinner></ngx-spinner>

    <div class="plans-area">
      <div class="innerPage plans-area-inner subscription-shell">

        <!-- Current Plan -->
        <section class="current-plan-section" *ngIf="userSubs && userSubs.length > 0">
          <h2 class="section-title">My Plan

          </h2>
          <div class="current-plan-card" *ngFor="let plan of userSubs">
            <div class="current-plan-info">
              <div class="current-plan-name">
                {{ plan?.caption ? plan?.caption : 'Base Plan' }}
              </div>
              <div class="current-plan-meta">
                <span class="status-pill active">Active</span>
                <span class="meta-item">Valid till {{ planExpire | date: 'MMM d, y' }}</span>
                <span class="meta-item">Total: ${{ getDisplayTotal(plan) }}</span>
              </div>
            </div>
            <button class="btn-cancel" (click)="clickcancel(plan?._id)">
              Cancel Subscription
            </button>
          </div>
        </section>

        <!-- Free Plan -->
        <!-- Free Plan -->
        <section class="current-plan-section" *ngIf="!userSubs || userSubs.length === 0">
          <h2 class="section-title">My Plan</h2>
          <div class="current-plan-card free-plan">
            <div class="current-plan-info">
              <div class="current-plan-name">Community Listing</div>
              <div class="current-plan-meta">
                <span class="status-pill active">Active</span>
                <span class="meta-item">Free — visible to your primary church or ministry</span>
              </div>
            </div>
            <div class="free-plan-kp-actions">
              <div class="kingdom-actions-row">
                <button class="kingdom-pill" (click)="requestKingdomPartnerFree()" [disabled]="
                  freeKpStatus === 'pending' ||
                  freeKpStatus === 'approved' ||
                  freeKpStatus === 'suspended'
                ">
                  <i class="fa fa-shield-alt"></i>
                  <span *ngIf="freeKpStatus === 'approved'">Approved</span>
                  <span *ngIf="freeKpStatus === 'pending'">Pending</span>
                  <span *ngIf="freeKpStatus === 'suspended'">Suspended</span>
                  <span *ngIf="freeKpStatus === 'rejected'">Rejected • Apply Again</span>
                  <span *ngIf="!freeKpStatus">Become Kingdom Partner</span>
                </button>

                <button class="kingdom-revert-btn" *ngIf="freeKpStatus === 'pending' || freeKpStatus === 'approved'"
                  [disabled]="freeKpStatus === 'approved'" (click)="revertKingdomPartnerFree()">
                  <i class="fa fa-undo"></i>
                  Revert
                </button>
              </div>
              <button class="btn-subscribe" (click)="setActiveTab('plans')">Upgrade</button>
            </div>
          </div>
        </section>

        <!-- Tabs -->
        <div class="subscription-tabs-wrap">
          <div class="subscription-tabs">
            <button class="subscription-tab" [class.subscription-tab--active]="activeTab === 'plans'"
              (click)="setActiveTab('plans')">
              Subscription Plans
            </button>
            <button class="subscription-tab" [class.subscription-tab--active]="activeTab === 'sponsors'"
              (click)="setActiveTab('sponsors')">
              Kingdom Sponsors
            </button>
          </div>
        </div>

        <!-- Subscription Plans Tab -->
        <section class="plans-section" *ngIf="activeTab === 'plans'">
          <div class="plans-header">
            <div class="plans-header-text">
              <h2 class="section-title">Subscription Plans</h2>
              <p class="section-subtitle">
                Choose the best plan to grow your business and community.
              </p>
            </div>
            <div class="stripe-badge">
              <i class="fa fa-lock"></i>
              <span>Secure payments powered by</span>
              <strong>stripe</strong>
            </div>
          </div>

          <div class="plans-loading" *ngIf="loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          <div class="plans-layout" *ngIf="!loading && displayPlans.length > 0">
            <div class="plans-grid">
              <article class="plan-card" *ngFor="let plan of displayPlans"
                [class.plan-card--popular]="getPlanConfig(plan).badgeType === 'popular'"
                [class.plan-card--growth]="getPlanConfig(plan).badgeType === 'growth'"
                [class.plan-card--founder]="hasEarlyBirdOffer(plan)" [class.plan-card--current]="isCurrentPlan(plan)"
                [class.plan-card--kingdom]="isKingdomPartnerSelected(plan)"
                [attr.data-accent]="getPlanConfig(plan).accent">
                <div class="plan-badge"
                  *ngIf="getPlanConfig(plan).badge && getPlanConfig(plan).badgeType !== 'earlybird' && !hasEarlyBirdOffer(plan)"
                  [class.plan-badge--popular]="getPlanConfig(plan).badgeType === 'popular'"
                  [class.plan-badge--growth]="getPlanConfig(plan).badgeType === 'growth'">
                  <i class="fa fa-star"></i>
                  {{ getPlanConfig(plan).badge }}
                  <i class="fa fa-star"></i>
                </div>

                <div class="early-bird-tag" *ngIf="hasEarlyBirdOffer(plan)">
                  <i class="fa fa-bolt"></i>
                  Early Bird Offer — $495
                </div>

                <div class="plan-card__body">
                  <div class="plan-card__header" [class.plan-card__header--founder]="hasEarlyBirdOffer(plan)">
                    <div class="plan-icon">
                      <i class="fa" [ngClass]="getPlanConfig(plan).icon"></i>
                    </div>
                    <h3 class="plan-title">{{ getPlanDisplayName(plan) }}</h3>
                    <p class="plan-subtitle">{{ getPlanConfig(plan).subtitle }}</p>
                  </div>

                  <div class="plan-pricing">
                    <ng-container *ngIf="hasEarlyBirdOffer(plan); else standardPrice">
                      <div class="price-row">
                        <span class="price-strike">${{ plan?.price || 995 }}</span>
                        <span class="price-amount accent">${{ getEarlyBirdPrice() }}</span>
                      </div>
                      <div class="price-note price-note--founder">One-time payment · Save $500</div>
                      <div class="limited-offer-pill">
                        <i class="fa fa-fire"></i>
                        Limited Offer — First 100 partners only
                      </div>
                    </ng-container>

                    <ng-template #standardPrice>
                      <div class="price-row">
                        <span class="price-amount accent">${{ getMonthlyPrice(plan) }}</span>
                        <span class="price-period">/ month</span>
                      </div>
                      <div class="price-note">{{ getAnnualBillingNote(plan) }}</div>
                    </ng-template>
                  </div>

                  <ul class="plan-features">
                    <li *ngFor="let feature of getPlanConfig(plan).features">
                      <i class="fa fa-check"></i>
                      <span>{{ feature }}</span>
                    </li>
                  </ul>

                  <div class="media-allowance" *ngIf="getPlanConfig(plan).mediaAllowance">
                    <i class="fa fa-image"></i>
                    {{ getPlanConfig(plan).mediaAllowance }}
                  </div>
                </div>

                <div class="plan-card__action-area">

                  <div class="kingdom-upgrade kingdom-upgrade--compact" *ngIf="supportsKingdomPartner(plan)">
                    <div class="kingdom-actions-row">

                      <button class="kingdom-pill" (click)="requestKingdomPartner(plan)" [disabled]="
  !isCurrentPlan(plan) ||
  plan.kingdom_partner_status === 'pending' ||
  plan.kingdom_partner_status === 'approved'||
  plan.kingdom_partner_status === 'suspended'
">

                        <i class="fa fa-shield-alt"></i>

                        <span *ngIf="plan.kingdom_partner_status === 'approved'">
                          Approved
                        </span>

                        <span *ngIf="plan.kingdom_partner_status === 'pending'">
                          Pending
                        </span>
                        <span *ngIf="plan.kingdom_partner_status === 'suspended'">
                          Suspended
                        </span>
                        <span *ngIf="plan.kingdom_partner_status === 'rejected'">
                          Rejected • Apply Again
                        </span>

                        <span *ngIf="!plan.kingdom_partner_status">
                          Become Kingdom Partner
                        </span>

                      </button>

                      <button class="kingdom-revert-btn" *ngIf="showRevertButton(plan)"
                        [disabled]="isRevertDisabled(plan)" (click)="revertKingdomPartner(plan)">
                        <i class="fa fa-undo"></i>
                        Revert
                      </button>

                    </div>
                  </div>

                </div>

                <div class="plan-card__footer">
                  <button class="plan-cta" [class.plan-cta--current]="isCurrentPlan(plan)"
                    [disabled]="isCurrentPlan(plan)" (click)="getSubscription(plan)">
                    {{ isCurrentPlan(plan) ? 'Current Plan' : getPlanConfig(plan).ctaLabel }}
                  </button>
                </div>
              </article>
            </div>

            <aside class="kingdom-benefits-panel">
              <h4 class="kingdom-benefits-panel__title">
                <i class="fa fa-crown"></i>
                Kingdom Partner Benefits
              </h4>
              <ul class="kingdom-benefits-panel__list">
                <li *ngFor="let benefit of kingdomPartnerBenefits; let i = index">
                  <span class="kingdom-benefits-panel__icon" [attr.data-index]="i">
                    <i class="fa fa-check"></i>
                  </span>
                  <span>{{ benefit }}</span>
                </li>
              </ul>
              <div class="kingdom-benefits-panel__footer">
                <i class="fa fa-shield-alt"></i>
                <span>Same plan price · More impact &amp; recognition</span>
              </div>
            </aside>
          </div>

          <div class="plans-compare-wrap" *ngIf="!loading && displayPlans.length > 0">
            <button class="btn-compare-center" (click)="subscriptionPage()">
              Compare plans
            </button>
          </div>

          <div class="plans-empty" *ngIf="!loading && displayPlans.length === 0">
            <p>Unable to load subscription plans right now.</p>
            <button class="btn-compare-card plans-empty__btn" (click)="subscriptionPage()">
              View plans on Ravel.Faith
            </button>
          </div>

          <div class="plans-disclaimer">
            *Subscription plans renew automatically until canceled.
            Cancelled subscriptions will continue for the duration of the plan period
            and then revert to the free Affiliate plan.
          </div>

          <p class="plans-footer">
            <i class="fa fa-lock"></i>
            Cancel anytime. Your subscription will continue until the end of the billing period.
          </p>
        </section>

        <!-- Kingdom Sponsors Tab -->
        <section class="sponsors-section" *ngIf="activeTab === 'sponsors'">
          <div class="plans-header">
            <div class="plans-header-text">
              <h2 class="section-title">Kingdom Sponsors Circle</h2>
              <p class="section-subtitle">
                Sponsor tiers are separate from subscription plans and support the Ravel mission at a higher level.
              </p>
            </div>
          </div>

          <div class="sponsors-grid">
            <article class="sponsor-card" *ngFor="let tier of sponsorTiers">
              <div class="sponsor-card__badge">Sponsor Level</div>
              <h3 class="sponsor-card__name">{{ tier.name }}</h3>
              <div class="sponsor-card__price">{{ tier.price }}</div>
              <p class="sponsor-card__desc">{{ tier.description }}</p>
              <button class="sponsor-card__cta" (click)="viewSponsorDetails()">
                View Sponsor Program Details
              </button>
            </article>
          </div>

          <p class="plans-footer">
            <i class="fa fa-info-circle"></i>
            Kingdom Sponsors are not subscription plans. Contact us for sponsor enrollment.
          </p>
        </section>

      </div>
    </div>
  </div>
</div>

<div id="myModal" class="modal" [ngClass]="{ show: isModalVisible }" (click)="onBackdropClick($event)">
  <div class="modal-content">
    <div class="cross">
      <p class="close" (click)="closeModal()">X</p>
    </div>
    <div class="modal-body">
      <div class="para">
        <p style="font-size: 26px; color: #d0550e; text-align: center">
          Choose a Global Plan<br />
        </p>
        <p style="font-size: 26px; color: black; text-align: center">
          Upgrade your free Affiliate profile and start <br />connecting with members of any congregation
        </p>
        <p style="font-size: 26px; color: black; text-align: center">Cancel anytime</p>
      </div>
    </div>
  </div>
</div>